<div class="settings-container">
  <h2 class="settings-title">Settings</h2>

  <div class="settings-section">
    <h3 class="section-heading">Appearance</h3>
    <div class="appearance-card">
      <mat-icon class="appearance-icon">dark_mode</mat-icon>
      <span class="appearance-label">Dark mode</span>
      <mat-slide-toggle
        [checked]="themeService.darkMode()"
        (change)="themeService.toggle()">
      </mat-slide-toggle>
    </div>
  </div>

  <div class="settings-section">
    <h3 class="section-heading">Configuration</h3>
    <div class="settings-grid">
      <a class="settings-card" routerLink="/settings/fish-types">
        <div class="settings-card-icon">🐟</div>
        <div class="settings-card-body">
          <h3>Fish Types</h3>
          <p>Add, edit, or disable fish species.</p>
        </div>
      </a>
      <a class="settings-card" routerLink="/settings/prompt-snippets">
        <div class="settings-card-icon">🧠</div>
        <div class="settings-card-body">
          <h3>Prompt Snippets</h3>
          <p>Configure the AI system prompt data for location analysis and trip reports.</p>
        </div>
      </a>
    </div>
  </div>

  <div class="settings-section">
    <h3 class="section-heading">System</h3>
    <div class="settings-grid">
      <a class="settings-card" routerLink="/settings/jobs">
        <div class="settings-card-icon">⏳</div>
        <div class="settings-card-body">
          <h3>Worker Jobs</h3>
          <p>Review queued, running, failed, and completed background jobs from the last 24 hours.</p>
        </div>
      </a>
    </div>
  </div>

  <div class="settings-section">
    <h3 class="section-heading">Reference</h3>
    <div class="settings-grid">
      <a class="settings-card" routerLink="/settings/processing">
        <div class="settings-card-icon">⚙️</div>
        <div class="settings-card-body">
          <h3>Processing Pipeline</h3>
          <p>How async jobs work: triggers, outputs, job tracking, and design patterns.</p>
        </div>
      </a>
      <a class="settings-card" routerLink="/settings/mcp-tools">
        <div class="settings-card-icon">🔌</div>
        <div class="settings-card-body">
          <h3>MCP Tools</h3>
          <p>All MCP tool parameters, return shapes, and usage patterns for external LLM system prompts.</p>
        </div>
      </a>
      <a class="settings-card" routerLink="/settings/mcp-system-prompt">
        <div class="settings-card-icon">🧭</div>
        <div class="settings-card-body">
          <h3>MCP System Prompt</h3>
          <p>Generated system prompt built from USER_PROFILE, KNOWN_WATERS, RULES, and concise tool guidance.</p>
        </div>
      </a>
    </div>
  </div>

  <div class="settings-section">
    <h3 class="section-heading">Version</h3>
    <div class="version-info">
      <div class="version-row">
        <span class="version-label">Frontend (cached)</span>
        <span class="version-value">{{ storedVersion }}</span>
      </div>
      <div class="version-row">
        <span class="version-label">API (live)</span>
        <span class="version-value">{{ apiVersion || '…' }}</span>
      </div>
    </div>
    <div style="margin-top: 16px;">
      <button mat-stroked-button color="warn" (click)="forceClearCache()">
        Clear Local Cache
      </button>
    </div>
  </div>
</div>
